var _path, _path2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8739 1.77027C8.85112 0.19051 11.1489 0.190505 12.1261 1.77026L18.4653 12.0181C19.4955 13.6836 18.2976 15.8333 16.3392 15.8333H3.66081C1.70241 15.8333 0.504452 13.6836 1.53471 12.0181L7.8739 1.77027Z",
    fill: "#7A67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.8739 18.2297C8.85112 19.8095 11.1489 19.8095 12.1261 18.2297L18.4653 7.98193C19.4955 6.31643 18.2976 4.16675 16.3392 4.16675H3.66081C1.70241 4.16675 0.504452 6.31643 1.53471 7.98193L7.8739 18.2297Z",
    fill: "url(#paint0_linear_3463_4826)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8168 10.1504C16.7764 13.4565 14.1227 16.4755 10.4167 16.4755C6.71062 16.4755 4.05697 13.4565 4.01654 10.1504C4.05697 6.84423 6.71062 3.8252 10.4167 3.8252C14.1227 3.8252 16.7764 6.84423 16.8168 10.1504Z",
    fill: "#855DE7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3463_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54169 7.30298L10.4167 9.33646L12.2917 7.30298",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22917 9.68091H12.6042",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22917 11.7146H12.6042",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 9.68091V13.409",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4826",
    x: 0.683207,
    y: 0.491862,
    width: 19.4669,
    height: 19.3171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667,
    result: "effect1_foregroundBlur_3463_4826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4826",
    x1: -2.5,
    y1: 10.0001,
    x2: 22.5,
    y2: 10.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3463_4826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.83333,
    height: 8.33333,
    fill: "white",
    transform: "translate(7.5 5.83325)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon5);
export default __webpack_public_path__ + "static/media/navicon5.43af91c5f5f8b0cdf371aea0dae958df.svg";
export { ForwardRef as ReactComponent };